export enum SchedulerRecurrenceTypeEnum {
  DAILY = 'DAILY',
  WEEKLY_NTH = 'WEEKLY_NTH',
  MONTHLY_NTH = 'MONTHLY_NTH',
  YEARLY = 'YEARLY',
  EVERY_MONDAY_TO_FRIDAY = 'EVERY_MONDAY_TO_FRIDAY',
  CUSTOM = 'CUSTOM',
}
